import BaseLayer from './BaseLayer';
import { wmsSourceTiles, setVisibility } from '../utils/maplibre-helpers';

export default class WmsLayer extends BaseLayer {
    getWmsConfig() {
        throw new Error(this.id + ' must implement getWmsConfig()');
    }

    getLayerIds() {
        return [this.id];
    }

    load() {
        if (!this.canActivate()) {
            this.clear();
            return;
        }

        const map = this.getMap();
        if (!map) return;

        const sourceId = this.getSourceId();
        if (!map.getSource(sourceId)) {
            const wms = this.getWmsConfig();
            const source = {
                type: 'raster',
                tiles: [wmsSourceTiles(wms.url, wms.params)],
                tileSize: wms.tileSize || 256,
                attribution: wms.attribution || ''
            };
            if (wms.sourceMaxZoom != null) source.maxzoom = wms.sourceMaxZoom;
            map.addSource(sourceId, source);
            map.addLayer({
                id: this.id,
                type: 'raster',
                source: sourceId,
                minzoom: wms.layerMinZoom != null ? wms.layerMinZoom : this.minZoom,
                maxzoom: wms.layerMaxZoom != null ? wms.layerMaxZoom : this.maxZoom,
                paint: {
                    'raster-opacity': wms.opacity != null ? wms.opacity : 1,
                    'raster-fade-duration': 0
                }
            });
        }
        setVisibility(map, this.id, true);

        if (this.config.onLoaded) {
            this.config.onLoaded();
        }
    }

    clear() {
        const map = this.getMap();
        if (map && map.getLayer(this.id)) {
            setVisibility(map, this.id, false);
        }
        this.removeLayerFromMap();
        if (this.config.onCleared) {
            this.config.onCleared();
        }
    }
}
